import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';

import { TrackingConsent } from '@mews/enums';
import { ConsentsObserver, DEFAULT_CONSENTS, TrackingConsentsService } from '@mews/framework';

export const createWidgetDistributorTrackingConsentsService = ({
    defaultConsents = DEFAULT_CONSENTS,
} = {}): TrackingConsentsService => {
    let currentConsents = defaultConsents;
    const observers = new Set<ConsentsObserver>();

    return {
        closePanel: () => {},
        getAllConsents() {
            return currentConsents;
        },
        initAndOpenBanner: async (_apiKey) =>
            Promise.resolve({
                isAlreadyInitialized: true,
                processTime: 0,
            }),
        isConsentGiven: (consent: TrackingConsent) =>
            pipe(
                currentConsents,
                option.fromNullable,
                option.map((allConsents) => allConsents[consent]),
                option.getOrElse<boolean>(() => false)
            ),
        openPanel: () => {},
        subscribeToConsents: (observer) => {
            observers.add(observer);
        },
        unsubscribeConsents: (observer) => {
            observers.delete(observer);
        },
        setDefaultConsents: (consents) => {
            currentConsents = consents;
            observers.forEach((observer) => observer(currentConsents));
        },
    };
};
